import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import CheckboxBlank from '@/assets/icons/checkbox-blank.svg';
import CheckboxMarked from '@/assets/icons/checkbox-marked.svg';
import CheckboxIndeterminate from '@/assets/icons/checkbox-indeterminate.svg';
import RadioOff from '@/assets/icons/radio-off.svg';
import RadioOn from '@/assets/icons/radio-on.svg';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#d7eef9', // blue
        secondary: '#1592e6',
        journey: '#d7eef9', // blue
        journeySecondary: '#1592e6',
        deepening: '#e9e0fe', // purple
        deepeningSecondary: '#9068de',
        lightening: '#fff48a', // yellow
        lighteningSecondary: '#f4dd00',
        anchor: '#0079ca',
        error: '#ec407a',
      },
    },
  },
  breakpoint: {
    thresholds: {
      xs: 0,
      sm: 340,
      md: 600,
      lg: 980,
      xl: 1440,
    },
  },
  icons: {
    values: {
      checkboxOff: {
        component: CheckboxBlank,
      },
      checkboxOn: {
        component: CheckboxMarked,
      },
      checkboxIndeterminate: {
        component: CheckboxIndeterminate,
      },
      radioOff: {
        component: RadioOff,
      },
      radioOn: {
        component: RadioOn,
      },
    },
  },
});
